const defaultType = {
    jpath: [],
    process() {
        return {};
    },
    getEmpty() {
        return [];
    },
};
export default defaultType;
//# sourceMappingURL=default.js.map